/**
 * Generic booking-hub utility for global navigation, sticky book bars, and
 * pages without a verified treatment slug. Treatment-specific page CTAs use
 * the shared map in `shared/bookingLinks.ts` instead.
 */

import { MEDSPARECORD_BOOKING_HUB } from "@shared/bookingLinks";

export const BOOKING_URL = MEDSPARECORD_BOOKING_HUB;

/** Returns the plain booking URL (kept as a function for drop-in compatibility). */
export function getBookingUrl(): string {
  return BOOKING_URL;
}

/** Alias — used by StickyBookBar and other components. Returns plain booking URL. */
export function getBookingUrlForPage(): string {
  return BOOKING_URL;
}
